/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Home_Trust_CountInputs */

const en_directory_home_trust_count = /** @type {(inputs: Directory_Home_Trust_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tools reviewed`)
};

const zh_directory_home_trust_count = /** @type {(inputs: Directory_Home_Trust_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已审阅 ${i?.count} 款工具`)
};

/**
* | output |
* | --- |
* | "{count} tools reviewed" |
*
* @param {Directory_Home_Trust_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_trust_count = /** @type {((inputs: Directory_Home_Trust_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Trust_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_trust_count(inputs)
	return zh_directory_home_trust_count(inputs)
});
export { directory_home_trust_count as "directory.home.trust_count" }